import React from 'react';

export const Button = ({ children, onClick, disabled = false, className = '' }) => (
    <button
        onClick={onClick}
        disabled={disabled}
        className={`w-full py-3 px-4 rounded-xl font-semibold transition duration-300 ${
            disabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#01a499] hover:bg-[#01857c] text-white shadow-lg shadow-[#01a499]/25'
        } ${className}`}
    >
        {children}
    </button>
);

export const Header = ({ title, onBack, rightContent }) => (
    <div className="flex items-center justify-between p-4 bg-white shadow-md sticky top-0 z-10">
        <button onClick={onBack} className="text-[#01a499] hover:text-[#017a72] transition duration-150">
            {onBack ? <ChevronLeft /> : <Leaf className="w-8 h-8 text-[#01a499]" />}
        </button>
        <h1 className="text-xl font-bold text-gray-800">{title}</h1>
        <div className="w-8 flex justify-end">{rightContent}</div>
    </div>
);
